/**
 * TEMA
 *
 * Varsayılan koyu temadır. Seçim tarayıcıda saklanır; sunucuya gitmez,
 * çünkü tema kullanıcının değil cihazın tercihidir (aynı hesap tablette
 * açık, atölye ekranında koyu kullanılabilir).
 */
export type Tema = 'koyu' | 'acik';

const ANAHTAR = 'nero.tema';

export function temayiOku(): Tema {
  try {
    return localStorage.getItem(ANAHTAR) === 'acik' ? 'acik' : 'koyu';
  } catch {
    return 'koyu';
  }
}

export function temayiUygula(tema: Tema): void {
  const kok = document.documentElement;
  if (tema === 'acik') kok.setAttribute('data-tema', 'acik');
  else kok.removeAttribute('data-tema');
  kok.style.colorScheme = tema === 'acik' ? 'light' : 'dark';
}

export function temayiYaz(tema: Tema): void {
  try { localStorage.setItem(ANAHTAR, tema); } catch { /* özel pencere: yalnızca bu oturum */ }
  temayiUygula(tema);
}
